import "./Share.scoped.scss";
import React from "react";
import { Link } from "react-router-dom";
import { PopupShare, Service_CN, onCopy } from "../../../utils/CommonFunc";
import { useRecoilValue } from "recoil";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { isLauncherState } from "../../../recoil/userInfoAtom";
import { isOpenShareState } from "../../../recoil/commonUiAtom";
import {
  faFacebookF,
  faXTwitter,
  faWeibo,
  faInstagram
} from "@fortawesome/free-brands-svg-icons";
import { t } from "i18next";
import { faCircle, faCopy } from "@fortawesome/free-regular-svg-icons";

function Share(props: { snsList: string }) {
  const isOpenShare = useRecoilValue(isOpenShareState);
  const sns = props.snsList.split("|").map((i) => i.toLowerCase());
  const isLauncher = useRecoilValue(isLauncherState);

  const snsType = (type: string) => {
    switch (type) {
      case "facebook":
        return faFacebookF;
      case "twitter":
        return faXTwitter;
      case "weibo":
        return faWeibo;
      case "instagram":
        return faInstagram;
      default:
        return faCircle;
    }
  };

  return isOpenShare ? (
    <span className="shareComponent">
      {sns.length !== 0
        ? sns.map((i: string, idx: number) => (
            <span className="Share-item" key={idx}>
              <Link
                to="#"
                onClick={() =>
                  PopupShare(i, window.location.href, sns[idx], isLauncher)
                }
              >
                <FontAwesomeIcon icon={snsType(i)} />
              </Link>
            </span>
          ))
        : null}
      {!Service_CN && (
        <FontAwesomeIcon
          icon={faCopy}
          className="Share-item"
          onClick={() =>
            onCopy(
              window.location.href,
              t("Link_copied"),
              t("Link_copying_is_not_possible")
            )
          }
        />
      )}
    </span>
  ) : null;
}

export default Share;
